import type { App } from 'vue'
import keepHtml from './keep-html'

export default function (app: App<Element>) {
  keepHtml(app)
}
